<template>
    <div>
        <div class="modal fade" id="progressOfListLesson" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"><i class="fa-solid fa-timeline"></i>
                            <strong> Tiến độ của học viên</strong>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="text-danger"><i
                                    class="fa-regular fa-circle-xmark"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="isLoading" class="d-flex justify-content-center container-loader">
                            <flower-spinner class="loading-component" :animation-duration="2000" :size="30"
                                color="#06C755" />
                        </div>
                        <div v-if="!isLoading">
                            <div v-for="(chapter, index) in chapters" :key="index">
                                <div>
                                    <div class="chapter-name">{{ chapter.chapter_name }}</div>
                                    <ul class="list-lesson">
                                        <li @click="gotoLesson(chapter.course_id, lesson)" class="lesson-name"
                                            v-for="(lesson, index2) in chapter.lessons" :key="index2">
                                            <span class="span-lesson-name">{{ lesson.lesson_name }}</span>
                                            <span v-if="lesson.completed" class="status-lesson status-completed">Đã hoàn
                                                thành</span>
                                            <span v-if="!lesson.completed"
                                                class="status-lesson status-not-completed ">Chưa hoàn thành</span>
                                            <span v-if="lesson.time"
                                                :class="{ 'text-success': lesson.completed, 'text-primary': !lesson.completed }"
                                                class="status-lesson"><i class="fa-solid fa-clock"></i> {{
                                                this.$formatTime(lesson.time) }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" ref="closeButton"
                            id="close">Đóng</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { FlowerSpinner } from 'epic-spinners';
export default {
    name: "ProgressOfListLesson",
    components: {
        FlowerSpinner,
    },
    props: {

    },

    data() {
        return {
            chapters: null,
            isLoading: false,
        }
    },
    mounted() {
        this.$onEvent('eventGetProgressOfListLesson', (chapters) => {
            this.chapters = chapters;
        });
        this.$onEvent('eventGetProgressOfListLessonLoading', (isLoading) => {
            this.isLoading = isLoading;
        });
    },
    methods: {
        gotoLesson: function (course_id, lesson) {
            this.$router.push({
                name: 'LessonAndChat',
                params: {
                    slug_name_course: 'course-slug-id-record-' + course_id,
                    slug_name_lesson: lesson.lesson_slug + '-id-record-' + lesson.id
                }
            });
        }
    }

}
</script>

<style scoped src="./student-courses-registered.css"></style>
<style scoped>
.modal-header .close {
    outline: none;
}

.loading-component {
    margin: 150px 0px
}

.lesson-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    list-style: square;
    cursor: pointer;
}

.span-lesson-name {
    margin-right: 10px;
}

.span-lesson-name:hover {
    color: var(--user-color);
    text-decoration: underline;
}

.chapter-name {
    font-size: 18px;
    font-weight: bold;
    color: var(--user-color);
}

.status-lesson {
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 6px;
    color: white;
    font-weight: bold;
}

.status-completed {
    background-color: green;
}

.status-not-completed {
    background-color: var(--user-color);
}

@media screen and (min-width: 1201px) {}

@media screen and (max-width: 1200px) {
    .modal-dialog {
        max-width: 400px;
        margin: 10px auto;
        font-size: 13px;
    }

    .modal-header {
        padding: auto;
    }

    .modal-header .close {
        font-size: 20px;
    }

    .btn {
        font-size: 13px;
    }
}

@media screen and (max-width: 992px) {
    .modal-dialog {
        max-width: 350px;
        margin: 10px auto;
        font-size: 11px;
        ;
    }

    .modal-header {
        padding: auto;
    }

    .modal-header .close {
        font-size: 18px;
    }

    .btn {
        font-size: 12px;
    }

    .modal-body {
        padding: 14px 14px 0 14px;
    }
}

@media screen and (max-width: 768px) {
    .modal-dialog {
        max-width: 320px;
        margin: 10px auto;
        font-size: 9px;
        ;
    }

    .modal-header {
        padding: auto;
    }

    .modal-header .close {
        font-size: 11px;
    }

    .btn {
        font-size: 10px;
    }

    .modal-body {
        padding: 14px 14px 0 14px;
    }

    .alert {
        padding: 8px;
    }
}

@media screen and (min-width: 425px) and (max-width: 575px) {
    .modal-dialog {
        max-width: 275px;
        margin: 10px auto;
        font-size: 9px;
        ;
    }

    .modal-header,
    .modal-footer {
        padding: 5px 5px;
    }

    .modal-header .close {
        font-size: 11px;
    }

    .btn {
        font-size: 8px;
    }

    .modal-body {
        padding: 12px 12px 0 12px;
    }

    .alert {
        padding: 8px;
    }
}

@media screen and (max-width: 424px) {
    .modal-dialog {
        max-width: 180px;
        margin: 10px auto;
        font-size: 7px;
        ;
    }

    .modal-header,
    .modal-footer {
        padding: 5px 5px;
    }

    .modal-header .close {
        font-size: 9px;
    }

    .btn {
        font-size: 7px;
    }

    .modal-body {
        padding: 11px 11px 0 11px;
    }

    .alert {
        padding: 6px 10px;
    }
}
</style>